import React, { useState, useEffect } from 'react';
import {
	Box,
	HStack,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Icon,
} from '@chakra-ui/react'
import { LuChevronDown } from 'react-icons/lu'
import CustomModal from '../../../components/CustomModal'
import CustomModalLink from '../../../components/CustomModalLink'
import PageLoader from '../../../components/Loader/PageLoader';
import Edit from './Edit';
import Create from './Create';

import { fetchWrapper } from '../../../helpers';

function Categories() {

	const { isOpen, onOpen, onClose } = useDisclosure();
	const { onOpen: onOpenEdit } = useDisclosure();
	const [isOpenEdit, setIsOpenEdit] = useState(false)
	const [modalEditView, setModalEditView] = useState(false)
	const [list, setList] = useState([])
	const [loading, setLoading] = useState(false);


	const meClose = () => {
		onClose();
	}

	useEffect(() => {
		loadList();
	}, [])

	const loadList = async () => {
		setLoading(true)
		const url = `${process.env.REACT_APP_API_URL}/category/list`;
		const data = await fetchWrapper.get(url)
		setList(data.data);
		setLoading(false)
	}

	const meEdit = (rs) => {
		setIsOpenEdit(true);
		setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
	}

	const meCloseEdit = () => {

		setIsOpenEdit(false);

	}

	return (
		<>

			<PageLoader isLoading={loading} />
			<CustomModalLink
				showModalButtonText="Template Messages Edit"
				modalHeader="Edit Category"
				isOpenEdit={isOpenEdit}
				onCloseEdit={meCloseEdit}
				onOpenEdit={onOpenEdit}

				modalBody={modalEditView}
			/>
			<div className="setting_detail_section">

				<HStack justifyContent="space-between">
					<Box>
						<h2 className="main_heading">Categories</h2>
					</Box>
					<Box>
						<CustomModal
							showModalButtonText="Add New Category"
							modalHeader="Add New Category"
							isOpen={isOpen}
							onClose={onClose}
							onOpen={onOpen}
							modalBody={<Create meClose={meClose} loadList={loadList} />}
						/>
					</Box>
				</HStack>

				<div className="table_section">
					<TableContainer width="100%">
						<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
							<Thead>
								<Tr>
									<Th width="15%">Category Name</Th>
									
									<Th width="5%"></Th>
								</Tr>
							</Thead>
							<Tbody fontSize="14px">
								{list.map((rs, index) => {
									return (									
											<Tr key={rs?.id || index}>
												<Td>{rs.name}</Td>									
												<Td style={{ color: "#0000EE" }}>
													<Menu>
														<MenuButton fontSize="14px" >
															Action

															<Icon as={LuChevronDown} />
														</MenuButton>

														<MenuList style={{ minWidth: "20px", border: "1px solid #CCCCCC" }}>
															<MenuItem h="16px" fontSize="12px" onClick={() => meEdit(rs)}>Edit</MenuItem>
														</MenuList>
													</Menu>
												</Td>
											</Tr>									
									)
								})}
							</Tbody>
						</Table>
					</TableContainer>
				</div>
			</div>
		</>
	)
}


export default Categories
